import { SupplementsGroupSubmitValues } from "../modals/SupplementsGroupModal/SupplementsGroupModal";

export const buildSupplementInput = (values: SupplementsGroupSubmitValues) => {
    const normalizedOptions = values.options.map((option) => ({
        ...(typeof option.id === "number" ? { id: option.id } : {}),
        name: option.name.trim(),
        price: option.price,
    }));

    return {
        groupName: values.groupName.trim(),
        items: values.items,
        options: normalizedOptions,
        isRequireOnOrder: values.isRequireOnOrder,
        maxCountOnOrder: values.maxCountOnOrder,
    };
};
